module.exports = __webpack_public_path__ + "static/media/c3d-vr-coding.e29dbdea.webp";